import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";

export function Footer({ isAsideToggled }) {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerLayout: objectPath.get(uiService.config, "footer.layout"),
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  return (
    <>
      <div className={`footer py-4 d-flex flex-lg-column ${layoutProps.footerClasses}`} id="kt_footer">
        <div className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}>
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-1">&copy; {today}</span>
            <a
              href="https://www.gamerji.com/"
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            >
              Gamerji e-Sports Private Limited, All rights reserved.
            </a>
          </div>
          <div className="nav nav-dark order-1 order-md-2">
            <a
              href="https://www.gamerji.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pr-3 pl-0"
            >
              About
            </a>
            <a
              href="https://www.gamerji.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link px-3"
            >
              Team
            </a>
            <a
              href="https://www.gamerji.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pl-3 pr-0"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
